<template>
  <div class="ck-document">
    <div class="ck-document-menu">
      <!--<div style="margin:10px">-->
        <!--<el-input-->
          <!--placeholder="请输入内容"-->
          <!--v-model="searchFile" >-->
          <!--<i slot="prefix" class="el-input__icon el-icon-search"></i>-->
        <!--</el-input>-->
      <!--</div>-->
      <div class="ck-document-menu_title flex-center"
           style="position:relative;background: rgba(31, 247, 255, 0.5)">
        <img src="../../assets/logo.png"/>
        <el-popover placement="bottom" trigger="hover"
                    style="top:20px;right:20px;cursor:pointer;position:absolute;" content="站点/内容管理">
          <span slot="reference" @click="function(){conType=!conType}">
            <i style="font-size:20px" class="el-icon-eleme"></i>
          </span>
        </el-popover>
        <!--<el-popover placement="bottom" trigger="hover"-->
                    <!--style="top:20px;right:20px;cursor:pointer;position:absolute;" content="收起">-->
          <!--<span slot="reference" @click="">-->
            <!--<i style="font-size:20px" class="el-icon-s-operation"></i>-->
          <!--</span>-->
        <!--</el-popover>-->
      </div>
      <el-tree
        ref="tree"
        :data="dataList"
        node-key="id"
        :current-node-key="currentNodeKey"
        :props="defaultProps"
        draggable
        :expand-on-click-node="false"
        default-expand-all
        auto-expand-parent
        :allow-drop="allowDrop"
        @node-drag-end="dropEnd"
        @node-click="handleNodeClick">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span :style="{'text-decoration':(!data.status||data.status==2?'line-through red':'')}">{{node.label}}</span>
          <span>
            <el-button v-if="!data.pid"  type="text" size="mini"  @click.stop="function(){append(data)}">Apd</el-button>
            <el-button type="text" size="mini" @click.stop="function(){remove(node, data)}">Del</el-button>
            <el-button v-if="data.status!=2" type="text" size="mini" @click.stop="function(){update_manualcatalog(data)}">
              {{!data.status?'open':'close'}}
            </el-button>
          </span>
        </span>
      </el-tree>
      <el-button size="mini" @click.stop="append({id:''})"><i class="el-icon-plus"></i>append</el-button>
    </div>
    <div class="ck-document-content" v-loading="!isFinish">
      <div v-show="!conType">
        <div style="text-align: left;width:860px;margin-top:40px;font-size:20px;font-weight: bold">站点管理</div>
        <div style="width:860px;margin-top:40px;">
          <div id="zhandian"></div>
          <el-button type="primary" @click="save_siteManagement">保存</el-button>
        </div>
      </div>
      <div v-show="conType">
        <div style="cursor:pointer;position:absolute;right:0px;top:60px;background: rgba(31, 247, 255, 0.5)" class="flex-col-center">
          <el-popover v-if="conType" placement="left" trigger="hover" content="编辑/浏览">
            <p slot="reference" @click="editOrLaunch">
              <i style="padding:10px 10px;font-size:20px" class="el-icon-view"></i>
            </p>
          </el-popover>
          <el-popover placement="left" trigger="hover" content="保存">
            <p slot="reference" @click="save_manualcontent">
              <i style="padding:10px 10px;font-size:20px" class="el-icon-upload"></i>
            </p>
          </el-popover>
        </div>
        <div v-show="type">
          <div style="color:#4a5de4;font-size:24px;font-weight:bold;border-bottom:1px solid #d1d5cb">
            <div style="text-align:left;max-width:800px;padding:10px 0">
              {{ruleForm.title}}
            </div>
          </div>
          <div v-html="mHtml" style="max-width:800px"></div>
          <div v-html="mFoot" style="max-width:800px"></div>
        </div>
        <div v-show="!type">
          <div style="text-align: left;width:860px;margin-top:40px;font-size:20px;font-weight: bold">内容管理</div>
          <el-form :model="ruleForm" label-position="left"
                   :rules="rules"
                   ref="ruleForm"
                   style="margin-top:20px;width:860px"
                   label-width="100px">
            <el-form-item label="栏目" prop="catalogName">
              <el-input v-model="ruleForm.catalogName"></el-input>
            </el-form-item>
            <el-form-item label="标题" prop="title">
              <el-input v-model="ruleForm.title"></el-input>
            </el-form-item>
            <el-form-item label="页面类型" prop="author" style="text-align: left">
              <el-radio-group v-model="radio">
                <el-radio :label="'模块类型'">模块类型</el-radio>
                <el-radio :label="'模块介绍'">模块介绍</el-radio>
                <el-radio :label="'模块封面'">模块封面</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="作者" prop="author">
              <el-input v-model="ruleForm.author"></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="content">
              <div id="summernote"></div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!--{{$route.query.id}}-->
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs'
  import $ from 'jquery'
    export default {
      name: "document",
      data() {
        return {
          id: 100,
          value:true,
          conType:true,//true为内容管理false为站点管理
          type:false,  //true为浏览false为编辑
          searchFile: '',
          dataList: [],
          currentNodeKey:'1',
          currentNode:{},
          radio:3,
          defaultProps: {
            children: 'children',
            label: 'label',
            pid:'pid',
            status:'status',
            orderNum:'orderNum',
            title:'title',
            author:'author',
          },
          isFinish:false,
          mHtml:'',
          mFoot:'',
          ruleForm: {
            catalogName: '',
            title:'',
            author:'',
          },
          rules: {
            catalogName: [
              { required: true, message: '请输入栏目', trigger: 'blur' },
              { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
            ],
            title: [
              { required: true, message: '请输入标题', trigger: 'blur' },
              { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
            ],
            author:[
              { required: true, message: '请输入作者', trigger: 'blur' },
              { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
            ],
            details: [
              { required: true, message: '请输入内容', trigger: 'blur' }
            ],
          },
        }
      },
      mounted(){
        this.initEditer("#summernote")
        this.initEditer("#zhandian")
        this.init().then(()=>{
          this.currentNode = this.dataList[0]
          this.httpList(this.dataList[0].id)
          this.get_by_id()
        })
      },
      methods: {
        initEditer(id){
          var HelloButton = function (context) {
            var ui = $.summernote.ui;

            // create button
            var button = ui.button({
              contents: '<i class="fa fa-child"/> Hello',
              tooltip: 'hello',
              click: function () {
                $(id).summernote('insertText', 'hello');
              }
            });

            return button.render();   // return button as jquery object
          }
          $(id).summernote({
            lang:'zh-CN',
            height: 300,
            width: 800,
            placeholder: '此处输入内容',
            // buttons: {
            //   hello: HelloButton
            // },
            toolbar: [
              ['mybutton', ['hello']],
              ['edit',['undo','redo']],//编辑
              ['headline', ['style']],//大字标题
              ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],//样式
              ['fontface', ['fontname','color','fontsize']],//字体
              ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],//对齐方式
              ['height', ['height']],//行高(自定义行高时一定不要忘记写这个)
              ['table', ['table']],//表单
              ['insert', ['link','picture','hr']],//插入链接，图片，下划线
              ['view', ['fullscreen', 'codeview']]//全屏，代码视图
            ],
            callbacks:{
              onImageUpload: function (files) {
                var formData = new FormData();
                formData.append("picFile", files[0]);
                $.ajax({
                  url: process.env.PUBLIC_URL+'/save_pic',
                  data: formData,
                  cache: false,
                  contentType: false,
                  processData: false,
                  type: 'POST',
                  success: function (data) {
                    $(id).summernote('insertImage', process.env.PUBLIC_URL+data.path);
                  },
                  fail:function(){
                    this.$message.error('错了哦，这是一条错误消息');
                  }
                });
              }
            }
          });
        },
        handleNodeClick(data) {
          if(this.ruleForm.catalogId != data.id){
            this.currentNode = data
            this.httpList(data.id)
          }
        },
        append(data) {
          const newChild = {catalogName:'新建文档',title:'新建文档',author:'',pid:data.id};
          axios({method: 'post',timeout: 30000,url:process.env.PUBLIC_URL+'/manual/save_manualcatalog',
            data:qs.stringify(newChild),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          }).then((res)=>{
            if(res.data.code==200){
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.init().then(()=>{this.$refs.tree.setCurrentKey(this.ruleForm.catalogId)})
            }
          })
        },
        remove(node, data) {
          axios({method: 'post',timeout: 30000,url:process.env.PUBLIC_URL+'/manual/delete',
            data:qs.stringify({id:data.id}),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          }).then((res)=>{
            console.log(res);
            if(res.data.code==200){
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.init().then(()=>{this.$refs.tree.setCurrentKey(this.ruleForm.catalogId)})
            }
          })
        },
        editOrLaunch(){
          this.type=!this.type;
          this.mHtml = $('#summernote').summernote('code')
        },
        save_siteManagement(){
          axios({method: 'post',timeout: 30000,url:process.env.PUBLIC_URL+'/siteManagement/save_siteManagement',
            data:qs.stringify({content:$("#zhandian").summernote("code")}),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          }).then((res)=>{
            if(res.data.code==200){
              this.$message({
                message: '站点更新成功',
                type: 'success'
              });
              this.conType = true
              this.type = true
              this.get_by_id()
            }else{
              this.$message.error('站点更新失败');
            }
          })
        },
        get_by_id(){
          axios({method: 'post',timeout: 30000,url:process.env.PUBLIC_URL+'/siteManagement/get_by_id',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          }).then((res)=>{
            this.mFoot = res.data.data.content
            $("#zhandian").summernote("code",this.mFoot)
          })
        },
        save_manualcontent(){
          this.ruleForm.details = $("#summernote").summernote("code");
          this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
              axios({method: 'post',timeout: 30000,url:process.env.PUBLIC_URL+'/content/update_manualcontent',
                data:qs.stringify({...this.ruleForm}),
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
              }).then((res)=>{
                if(res.data.code == 200){
                  this.$message({
                    message: '更新成功',
                    type: 'success'
                  });
                  this.init().then(()=>{
                    this.type = true
                    this.httpList(this.ruleForm.catalogId)
                  })
                }
              })
            }else{
              this.$message({
                message: '请将信息填写完整',
                type: 'warning'
              });
            }
          })
        },
        update_manualcatalog(data){
          axios({method: 'post',timeout: 30000,url:process.env.PUBLIC_URL+'/manual/change_status',
            data:qs.stringify({id:data.id,status:data.status?0:1}),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          }).then((res)=>{
            if(res.data.code==200){
              this.$message({
                message: '更新成功',
                type: 'success'
              });
              this.init().then(()=>{
                this.httpList(this.ruleForm.catalogId)
              })
            }
          })
        },
        allowDrop(draggingNode, dropNode, type) {
          if ((draggingNode.childNodes.length==0||(draggingNode.level===1&&dropNode.level===1))
            &&draggingNode.data.level === dropNode.data.level) {
            if (draggingNode.data.aboveId === dropNode.data.aboveId) {
              return type === 'prev' || type === 'next'
            }
          } else {
            return false
          }
        },
        dropEnd(draggingNode, dropNode, type){
          console.log(draggingNode, dropNode, type)
          let data = this.dataList.map((item)=>{
            let children = item.children&&item.children.map((itemChild)=>{return {id:itemChild.id}})
            return {id:item.id,children:children}
          })
          axios({method: 'post',timeout: 30000,url:process.env.PUBLIC_URL+'/manual/change_position',
            data:qs.stringify({orderList:JSON.stringify(data)}),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          }).then((res)=>{
            this.init().then(()=>{this.$refs.tree.setCurrentKey(this.ruleForm.catalogId)})
          })
        },
        init(){
          return axios({method: 'post',timeout: 30000,url:process.env.PUBLIC_URL+'/manual/get_all_manual',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          }).then((res)=>{
            this.isFinish = true;
            this.dataList = res.data.data.map((item)=>{
              let child = item.secManual.map((itemChild)=>{
                return {
                  id:itemChild.id+'',
                  label: itemChild.catalogName,
                  pid:itemChild.pid,title:itemChild.title,
                  status:item.status?itemChild.status:'2',
                  orderNum:itemChild.orderNum,author:itemChild.author
                }
              }).sort((avg1,avg2)=>{
                return avg1.orderNum>avg2.orderNum
              })
              return {
                id:item.id+'',
                label: item.catalogName,
                children: child,title:item.title,
                status:item.status,
                orderNum:item.orderNum,author:item.author
              }
            }).sort((avg1,avg2)=>{
              return avg1.orderNum>avg2.orderNum
            })
          })
        },
        httpList(id){
          this.$refs.tree.setCurrentKey(id)
          this.currentNodeKey = id
          axios({
            method: 'post',url:process.env.PUBLIC_URL+'/content/get_by_catalogId',timeout: 30000,
            data:qs.stringify({catalogId:id}),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          }).then((res)=>{
            this.mHtml =  res.data.data&&res.data.data.details||''
            $("#summernote").summernote("code",this.mHtml);
            this.ruleForm.catalogName = res.data.data&&res.data.data.catalogName||''
            this.ruleForm.title = res.data.data&&res.data.data.title||''
            this.ruleForm.author = res.data.data&&res.data.data.author||''
            this.ruleForm.catalogId = res.data.data&&res.data.data.catalogId||''
            this.ruleForm.pageType = res.data.data&&res.data.data.pageType||''
            this.radio = res.data.data&&res.data.data.pageType||''
          })
        }
      }
    }
</script>

<style>
  .el-popover{
    padding:5px 10px !important;
    min-width:50px !important;
  }
  .ck-document {
    height: 100%;
    display: flex;
  }
  .flex-center{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .flex-col-center{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .ck-document .ck-document-menu {
    width: 300px;
    height: 100%;
    background: #4C4C4C;
    color: #fff;
    overflow: auto;
  }
  .ck-document .ck-document-menu .ck-document-menu_title {
    height: 150px;
  }
  .ck-document .ck-document-menu .el-tree {
    background: transparent !important;
    color: #fff !important;
  }
  .ck-document .ck-document-menu .el-tree .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .ck-document .ck-document-menu .el-tree .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .ck-document .ck-document-menu .el-tree .custom-tree-node .el-input__inner{
    background: transparent;
    height:auto;
    line-height: 1;
    color:#fff;
    padding:5px 0;
  }
  .ck-document .ck-document-menu .el-tree .el-tree-node {
    padding-left: 10px;
  }
  .ck-document .ck-document-menu .el-tree .el-tree-node:focus > .el-tree-node__content {
    background: transparent !important;
    color: #fff !important;
  }
  .ck-document .ck-document-menu .el-tree .is-current {
    background: transparent !important;
  }
  .ck-document .ck-document-menu .el-tree .is-current:focus > .el-tree-node__content {
    background: transparent !important;
    color: rgba(31, 247, 255, 0.98) !important;
  }
  .ck-document .ck-document-menu .el-tree .is-current > .el-tree-node__content {
    background: transparent !important;
    color: rgba(31, 247, 255, 0.98) !important;
  }
  .ck-document .ck-document-menu .el-tree .el-tree-node__content {
    padding: 10px 0;
    height: auto;
  }
  .ck-document .ck-document-menu .el-tree .el-tree-node__content:hover {
    background: transparent !important;
    color: #fff !important;
  }
  .ck-document .ck-document-menu .el-tree .el-tree-node__content:hover span:last-child {
    color: rgba(31, 247, 255, 0.98) !important;
  }
  .ck-document .ck-document-content {
    width: calc(100% - 200px);
    height: 100%;
    overflow: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/document/document.vue